"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexMixin = void 0;
var _styledComponents = require("styled-components");
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _mediaQueryMixin = require("../mediaQueryMixin");
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
var ATTRIBUTES = ['display', 'flexFlow', 'flexDirection', 'flexWrap', 'justifyContent', 'alignItems', 'alignContent', 'flex', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'alignSelf'];
var flexCSS = function flexCSS(props) {
  var styles = [];
  var _loop = function _loop() {
    var attr = ATTRIBUTES[i];
    if (attr in props) {
      var cssAttr = attr.replace(/([A-Z])/g, function (g) {
        return "-" + g[0].toLowerCase();
      });
      styles.push((0, _inlineMediaQueryMixin.inlineMediaQueryMixin)(attr, function (mediaProps) {
        return cssAttr + ": " + mediaProps[attr] + ";";
      })(props));
    }
  };
  for (var i = 0; i < ATTRIBUTES.length; i += 1) {
    _loop();
  }
  return styles;
};
var gapCSS = function gapCSS(props) {
  return props.gap ? (0, _styledComponents.css)(["gap:", ";"], (0, _spaceMixin.spaceMixin)(props.gap)(props)) : '';
};

/** @class FlexMixin */
/** @method */
var FlexMixin = function FlexMixin(props) {
  return [flexCSS(props), (0, _inlineMediaQueryMixin.inlineMediaQueryMixin)('gap', gapCSS)(props), (0, _mediaQueryMixin.mediaQueryMixin)(function (mediaProps) {
    return flexCSS(mediaProps);
  }), (0, _spacingMixin.spacingMixin)(props)];
};
exports.FlexMixin = FlexMixin;